import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const AITextingAgent = () => {
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'stars'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'aiTextingAgent'}
      >
        Enrolled in AI Texting Agent
      </Typography>
    </div>
  )
}
